/** Angular `company-list` `searchCompany`: length > 0 and even. */
export function shouldRunCompanyAutocompleteSearch(searchText: string): boolean {
    return searchText.length > 0 && searchText.length % 2 === 0
}

/** Angular `company-list` `searchOrganization`: even length (including empty). */
export function shouldRunOrganizationTypeaheadSearch(searchText: string): boolean {
    return searchText.length % 2 === 0
}
